import { Dict } from "@lana-commerce/core/commonTypes";

import { CategoryBrief } from "../data/def";
import { LinkSpec } from "../components/linkSpec";
import { MenuItemFragment } from "../graphql/types";
import { UI } from "../state/async/core";

export function getMenuItemLink(briefs: Dict<CategoryBrief>, item: MenuItemFragment): string | undefined {
  if (item.type === "category") {
    if (!item.category) return "/";
    const c = briefs[item.category.id];
    return c?.featured ? c.relativeUrl : undefined;
  } else if (item.type === "content_block") {
    return item.content_block ? `/pages/${item.content_block.handle}` : "/";
  } else if (item.type === "product") {
    return item.product ? `/products/${item.product.handle}` : "/";
  } else if (item.type === "search") {
    // TODO: search query?
    return "/";
  } else if (item.type === "link") {
    // TODO: properly make external link
    return item.link || "/";
  } else {
    return "/";
  }
}

const allPages = [
  "profile" as const,
  "addresses" as const,
  "orders" as const,
  "store_credit" as const,
  "payment_methods" as const,
  "favorites" as const,
];

function showProfileOnClick(p: (typeof allPages)[0]) {
  return () => {
    UI.showCustomerProfile({ kind: p, action: "push" });
  };
}

export function getMenuItemLinkSpec(briefs: Dict<CategoryBrief>, item: MenuItemFragment): LinkSpec {
  if (item.type === "category") {
    if (!item.category) return { kind: "link", to: "/" };
    const c = briefs[item.category.id];
    return c?.featured ? { kind: "link", to: c.relativeUrl } : { kind: "text" };
  } else if (item.type === "content_block") {
    return { kind: "link", to: item.content_block ? `/pages/${item.content_block.handle}` : "/" };
  } else if (item.type === "product") {
    return { kind: "link", to: item.product ? `/products/${item.product.handle}` : "/" };
  } else if (item.type === "search") {
    // TODO: search query?
    return { kind: "link", to: "/" };
  } else if (item.type === "link") {
    // TODO: properly make external link
    return { kind: "external-link", href: item.link || "https://wikipedia.com" };
  } else if (item.type === "meta") {
    const p = allPages.find((p) => item.meta === p);
    if (p) {
      return { kind: "button", onClick: showProfileOnClick(p) };
    }
    return { kind: "link", to: "/" };
  } else {
    return { kind: "link", to: "/" };
  }
}
